<template>
  <select :id="id" class="custom-select custom-select-lg" :class="classState" @change="emitSelectClicked" :disabled="disabled">
    <option v-if="optionDefault" :selected="false" value="defaultOption">{{ optionDefault }}</option>
    <option
      v-for="option in options" 
      :key="option" 
      :value="option.id"
      :selected="modelValue === option.id ? true : false"
    >{{option[target]}}</option>
  </select>
</template>

<script>
export default {
  name: "BaseSelect",
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  props: {
    id: [Number, String],
    options: Array,
    modelValue: [Number, String, Boolean],
    optionDefault: 
    {
      type: [String,Boolean],
      default: null,
    },
    classState: String,
    isError: {
      type: Boolean,
      default: false
    },
    isModified: {
      type: Boolean,
      default: false
    },
    disabled:{
      type:Boolean,
      default: false
    },
    target: {
      type: String,
      default: "label"
    },
    actionType: {
      type: String,
      default: "emit"
    },
    isNumber:{
      type:Boolean,
      default : true
    },
    pubreqData: Array,
    small: {
      type: Boolean,
      default: false
    }
  },

  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  methods: {
    emitSelectClicked: function (event) {
      let newValue = event.target.value;
      if (this.isNumber && !isNaN(newValue))
        newValue = parseFloat(newValue);
    
      this.$emit("SelectClicked", { id: this.id, value: newValue});
    },
  }
};
</script>

<style lang="scss" scoped>
  .select-trinnov {
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px 4px 0px 0px;
    padding-left: 1vw;
    cursor: pointer;
    font-weight: 200;
    color: white !important;
    background: $grayDark2 url("data:image/svg+xml,%3csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6.16216 9L0 0H12L6.16216 9Z' fill='%23D3D3D3'/%3e%3c/svg%3e") right 0.75rem center/8px 1.2vh no-repeat;
    height: 4vh;
    font-size: 2vh;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-appearance: none;  /* Safari et Chrome */
    -moz-appearance: none;     /* Firefox */
    appearance: none;

    &.disabled {
      color: $default !important;
      background-color: transparent !important;
      cursor: default;
    }

    option {
      border: 0.5px solid $active;
      background-color: $hover !important;
      color: $white;
      font-weight: 200;

      @media only screen and (max-height: 700px) {
        font-size: 4vh;
      }
    }  
  }
</style>